import { FC, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { ProveedoresSalidasKPI } from "../ProveedoresInternosLayout/ProveedoresSalidas/ProveedoresSalidasKPI/ProveedoresSalidasKPI";

export const TransporteLayout:FC<any> = (props):JSX.Element => {

  const { kpisTransporte, comparativa, stateTransporte,filtered,tabID } = props

  const [ state3, setState3 ] = useState<any>(stateTransporte)

  return (
    <div className="proveedoresinternos-layout__wrapper"> 
        <div className="psalidas-top">
            <div className="psalidas-kpicontainer" style={{border: '1px solid lightgray',display:'flex',justifyContent:'space-around'}}>
              {
                kpisTransporte.map((kpi:any) => {
                  return (
                    <ProveedoresSalidasKPI title={kpi.title} valueA={kpi.valueA} valueB={kpi.valueB} tabID={tabID} comparativa={comparativa} transporte={true} filtered={filtered}/>
                  )
                })
              }
              
            </div>
        </div>
        <div className="chart-of" style={{width:'100%',height:'60%'}}>
            <ReactApexChart options={state3?.options} series={state3?.series.map((s:any) => ({...s,data:s.data.map((d:any) => {if(d === 0) {
                    return 0.000001
                }
                return d
                })
                }))} type="bar" height={'100%'} />
        </div>
    </div>
  )
}